import { useTranslation } from 'react-i18next';
import { usePortfolio } from '../../hooks/usePortfolio';

interface ProjectItem {
  name: string;
  description: string;
  description_en: string;
  techStack: string[];
  url?: string;
}

export function Projects() {
  const { t, i18n } = useTranslation();
  const { data, loading } = usePortfolio<ProjectItem>('PROJECT');
  const isEn = i18n.language === 'en';

  return (
    <section id="projects" className="py-24 px-6">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-mono text-sm text-accent">{`// ${t('nav.projects')}`}</h2>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {loading ? (
            [1, 2].map((i) => (
              <div key={i} className="h-40 animate-pulse rounded border border-border bg-bg-surface" />
            ))
          ) : (
            data.map((project, idx) => (
              <div key={idx} className="group rounded border border-border bg-bg-surface p-6 transition-colors hover:border-accent">
                <h3 className="text-lg font-semibold group-hover:text-accent">{project.name}</h3>
                <p className="mt-2 text-sm text-text-muted leading-relaxed">
                  {isEn ? project.description_en : project.description}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {project.techStack.map((tech, i) => (
                    <span key={i} className="font-mono text-xs text-text-muted">
                      {tech}{i < project.techStack.length - 1 ? ' ·' : ''}
                    </span>
                  ))}
                </div>
                {project.url && (
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-block font-mono text-xs text-accent hover:underline"
                  >
                    View project →
                  </a>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
